import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { adminInput } from "@/components/admin/ui";

export default function AdminLogin() {
  const { user, login } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const res = await login(email, password);
    if (!res.ok) setError(res.error);
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-wood-deep grain flex items-center justify-center px-6 py-16">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-sm bg-cream border border-wood/20 p-8"
      >
      <img
        src="/logo-osteria-aterrana.png"
        alt="Osteria Aterrana"
        className="mx-auto h-14 w-auto"
      />
      <p className="mt-6 eyebrow text-sage">Area riservata</p>
      <h1 className="mt-3 font-serif text-3xl text-wood">Pannello</h1>
        <p className="mt-2 text-sm text-foreground/60">Accedi per gestire prenotazioni e contenuti.</p>

        <div className="mt-8 space-y-4">
          <label className="block">
            <span className="text-[0.62rem] uppercase tracking-[0.16em] text-wood/55">Email</span>
            <input
              type="email"
              autoComplete="username"
              data-testid="admin-email"
              className={`${adminInput} mt-1.5`}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <label className="block">
            <span className="text-[0.62rem] uppercase tracking-[0.16em] text-wood/55">Password</span>
            <input
              type="password"
              autoComplete="current-password"
              data-testid="admin-password"
              className={`${adminInput} mt-1.5`}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
        </div>

        {error && (
          <p className="mt-5 border border-destructive/40 bg-destructive/5 px-3 py-2.5 text-sm text-destructive" role="alert" data-testid="admin-login-error">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={busy}
          data-testid="admin-login-submit"
          className="mt-7 w-full inline-flex items-center justify-center gap-2 bg-sage px-6 py-3.5 text-[0.68rem] uppercase tracking-[0.2em] text-cream hover:bg-wood transition-colors duration-500 disabled:opacity-50"
        >
          {busy && <Loader2 size={14} className="animate-spin" />} Accedi
        </button>
      </form>
    </div>
  );
}
